module.exports = __webpack_public_path__ + "img/success-message.ee0e2f07.svg";